<template>
  <div>
    <Breadcrumb :title="'Partner Information Upload'"></Breadcrumb>
    <div class="row no-gutters">
      <div class="col">
        <button class="btn btn-primary" style="float:right;" @click.prevent="downloadTemplate">
          <span class="k-icon k-i-download"></span>&nbsp;Download Template
        </button>
        <button
          class="btn btn-secondary"
          style="float:right;margin-right:10px;"
          @click.prevent="backtoPartner"
        >
          <span class="k-icon k-i-undo"></span> &nbsp;Back to Partner Information
        </button>
      </div>
    </div>
    <div class="row">
      <br>
    </div>
    <BaseAuditDropzone
      ref="ParentFileUploaded"
      :acceptedFileTypes="SheetJSFT"
      @change="_change"
      @Remove="ClearForm"
      :File="inputfile"
      :UploadType="FileUploadType"
    ></BaseAuditDropzone>
    <br>
    <div
      ref="refCustomerror"
      id="Customerror"
      class="alert alert-danger"
      role="alert"
      v-show="customerrors.length"
    >
      <span v-show="customerrors.length" class="alert-danger">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in customerrors" :key="error">{{ error }}</li>
        </ul>
      </span>
    </div>
    <br>
    <div v-show="displayPage">
      <div class="form-row">
        <div class="col-md-12">
          <BaseGrid
            :mode="'editform'"
            :config="PartnerInfoUploadConfig"
            :data="gridDataPartnerInfoExcel"
            @DeleteItem="DeleteDIfromGrid"
            @EditItem="EditPartner"
          ></BaseGrid>
        </div>
      </div>
      <div class="row">
        <PartnerInfoForm
          ref="refPartnerInfoForm"
          :PartnerInfoFormConfig="PartnerInfoJSON"
          :BulkImportPartnerEdit="BulkImportPartnerEdit"
          :PartnerModalLabel="modalConfig"
          @SaveComplete="refreshGrid"
        ></PartnerInfoForm>
        <br>
      </div>
      <div class="row no-gutters" style="float: right;margin-left:15px;">
        <button
          type="button"
          id="btnSave"
          class="btn btn-primary"
          :disabled="!isValid||flgValid ||gridDataPartnerInfoExcel.length<=0"
          @click.prevent="SavePartner"
        >Save</button>
      </div>
      <div class="row no-gutters" style="float: right;">
        <button
          type="button"
          id="btnValidate"
          class="btn btn-secondary"
          @click.prevent="validateFn"
        >Validate</button>
      </div>
      <div class="row">
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import sheetJSConfig from "@/configs/sheetJS.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import XLSX from "xlsx";
import { mapActions, mapState, mapGetters } from "vuex";
import { PartnerInfoUploadConfig } from "@/views/summaries/PartnerInfoUploadConfig.js";
import { isNullOrUndefined } from "util";
import PartnerInfoForm from "@/components/forms/PartnerForm.vue";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelCountries from "@/models/BaseModelCountries.js";
import BaseModelStates from "@/models/BaseModelStates.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
	components: {
    BaseGrid,
    Breadcrumb,
    BaseAuditDropzone,
    PartnerInfoForm
  },
  mixins: [
		apiUtil, 
    funcUtil,
    DocumentManagerMixin
	],
  data() {
    return {
      data: "",
      inputfile: {
        UploadFile: {}
      },
      isValid:false,
      displayPage: false,
      FileUploadType: {
        AllowMultiple: "false"
      },
      SheetJSFT: sheetJSConfig.fileType,
      PartnerInfoUploadConfig: PartnerInfoUploadConfig,
      BaseModelPartner: BaseModelPartner,
      BaseModelInputControl: BaseModelInputControl,
      dataPartnerInfoExcel: [],
      gridDataPartnerInfoExcel: [],
      bulkUploadAuditConfig: bulkUploadAuditConfig,
      // Add/Edit Partner data modal implementation
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      PartnerInfoJSON: { 
				parent: {}, 
				children: {} 
			},
      BulkImportPartnerEdit: true,
      customerrors: [],
      Columns: [],
      flgValid: true
    };
  },
  computed: {
    ...mapGetters("getModule", ["withFilter", "getLocalInputControls"])
  },
  methods: {
    ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),

    downloadTemplate() {
     let token = localStorage.getItem("eum")
           let templateUrl = getUrl("PartnerInfoExcel");
           let templateFileName = getFileName("PartnerInfoExcel");
            
           this.$http({
              url: templateUrl,
              method: 'GET',
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
    },

    _change(evt) {
      const files = this.inputfile.UploadFile[0];
      if (files) this._file(files);
    },

    backtoPartner: function(e) {
      e.preventDefault();
      this.$router.push("/configuration/partner");
    },

    _file(file) {
      /* Boilerplate to set up FileReader */
      try {
        const self = this;
        const reader = new FileReader();
        reader.onload = e => {
          /* Parse data */
          //const bstr = e.target.result;
          let binary = "";
          let bytes = new Uint8Array(e.target.result);
          let length = bytes.byteLength;

          for (let i = 0; i < length; i++) 
          {
              binary += String.fromCharCode(bytes[i]);
          }
          const bstr = binary
          const wb = XLSX.read(bstr, {
            type: "binary"
          });
          /* Get Partner  data */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, {
						range: sheetJSConfig.template.header - 1, 
            header: 1
          });
          console.log(data);
          data.splice(0, 1);

          if (data && data.length) {
            self.displayPage = true;
            self.Columns = [];

            var PartnerInfoExcelArr = [];
            var count = 1;
            for (var i = 0; i < data.length; i++) {
              var PartnerInfoExcelObj = {
                parent: {},
                children: {}
              };

              PartnerInfoExcelObj.parent.PartnerInfoKey = count++;
              PartnerInfoExcelObj.parent.Prefix = !isNullOrUndefined(
                data[i][0]
              )
                ? data[i][0].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.FirstName = !isNullOrUndefined(
                data[i][1]
              )
                ? data[i][1].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.MiddleName = !isNullOrUndefined(
                data[i][2]
              )
                ? data[i][2].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.LastName = !isNullOrUndefined(
                data[i][3]
              )
                ? data[i][3].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.Suffix = !isNullOrUndefined(
                data[i][4]
              )
                ? data[i][4].toString().trim()
                : "";

              PartnerInfoExcelObj.parent.EntityName = !isNullOrUndefined(
                data[i][5]
              )
                ? data[i][5].toString().trim()
                : "";

              if (PartnerInfoExcelObj.parent.EntityName) {
                PartnerInfoExcelObj.parent.FullName =
                  PartnerInfoExcelObj.parent.EntityName;
              } else {
                PartnerInfoExcelObj.parent.FullName =
                  PartnerInfoExcelObj.parent.Prefix+ 
                   " " +
                  PartnerInfoExcelObj.parent.FirstName +
                  " " +
                  PartnerInfoExcelObj.parent.MiddleName +
                  " " +
                  PartnerInfoExcelObj.parent.LastName+
                  " "+
                  PartnerInfoExcelObj.parent.Suffix;
              }

              PartnerInfoExcelObj.parent.TSDocId = !isNullOrUndefined(
                data[i][6]
              )
                ? data[i][6].toString().trim()
                : null;
              PartnerInfoExcelObj.parent.TaxId = !isNullOrUndefined(data[i][7])
                ? data[i][7].toString().trim()
                : null;

              PartnerInfoExcelObj.parent.HireDate = self._getExcelPlatformCode(data[i][8]);
              // !isNullOrUndefined(
              //   data[i][8]
              // )
              //   ? moment(
              //       new Date(Math.round((data[i][8] - 25569) * 86400 * 1000))
              //     ).format("MM/DD/YYYY")
              //   : null;

              PartnerInfoExcelObj.parent.LeaveDate = self._getExcelPlatformCode(data[i][9]);
              // !isNullOrUndefined(
              //   data[i][9]
              // )
              //   ? moment(
              //       new Date(Math.round((data[i][9] - 25569) * 86400 * 1000))
              //     ).format("MM/DD/YYYY")
              //   : null;

              PartnerInfoExcelObj.parent.PartnerStatus = !isNullOrUndefined(
                data[i][10]
              )
                ? this._firstLetterToUpper(data[i][10].toString().trim())
                : null;
              PartnerInfoExcelObj.parent.Position = !isNullOrUndefined(
                data[i][11]
              )
                ? this._firstLetterToUpper(data[i][11].toString().trim())
                : null;
              PartnerInfoExcelObj.parent.MemoGroup = !isNullOrUndefined(
                data[i][31]
              )
                ? data[i][31].toString().trim()
                : null;
              PartnerInfoExcelObj.parent.Domestic = !isNullOrUndefined(
                data[i][12]
              )
                ?this._firstLetterToUpper(data[i][12].toString().trim())
                : null;
              PartnerInfoExcelObj.parent.DocumentDeliveryMethod = !isNullOrUndefined(
                data[i][13]
              )
                ?this._firstLetterToUpper(data[i][13].toString().trim())
                : null;
              PartnerInfoExcelObj.parent.EMail = !isNullOrUndefined(
                data[i][14]
              )
                ?data[i][14].toString().trim()
                : null;
              PartnerInfoExcelObj.parent.Address1 = !isNullOrUndefined(
                data[i][15]
              )
                ? data[i][15].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.Address2 = !isNullOrUndefined(
                data[i][16]
              )
                ? data[i][16].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.City = !isNullOrUndefined(data[i][17])
                ? data[i][17].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.State = !isNullOrUndefined(data[i][18])
                ? data[i][18].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.Country = !isNullOrUndefined(
                data[i][19]
              )
                ? data[i][19].toString().trim()
                : "";
              PartnerInfoExcelObj.parent.PostalCode = !isNullOrUndefined(
                data[i][20]
              )
                ? data[i][20].toString().trim()
                : null;

              PartnerInfoExcelObj.parent.CheckMailAddress = !isNullOrUndefined(
                data[i][21]
              )
                ? data[i][21].toString().trim()
                : null;

              if (PartnerInfoExcelObj.parent.CheckMailAddress == "Yes") {
                PartnerInfoExcelObj.parent.MailAddress1 = !isNullOrUndefined(
                  data[i][15]
                )
                  ? data[i][15].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailAddress2 = !isNullOrUndefined(
                  data[i][16]
                )
                  ? data[i][16].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailCity = !isNullOrUndefined(
                  data[i][17]
                )
                  ? data[i][17].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailState = !isNullOrUndefined(
                  data[i][18]
                )
                  ? data[i][18].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailCountry = !isNullOrUndefined(
                  data[i][19]
                )
                  ? data[i][19].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailPostalCode = !isNullOrUndefined(
                  data[i][20]
                )
                  ? data[i][20].toString().trim()
                  : null;
              } else {
                PartnerInfoExcelObj.parent.MailAddress1 = !isNullOrUndefined(
                  data[i][22]
                )
                  ? data[i][22].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailAddress2 = !isNullOrUndefined(
                  data[i][23]
                )
                  ? data[i][23].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailCity = !isNullOrUndefined(
                  data[i][24]
                )
                  ? data[i][24].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailState = !isNullOrUndefined(
                  data[i][25]
                )
                  ? data[i][25].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailCountry = !isNullOrUndefined(
                  data[i][26]
                )
                  ? data[i][26].toString().trim()
                  : "";
                PartnerInfoExcelObj.parent.MailPostalCode = !isNullOrUndefined(
                  data[i][27]
                )
                  ? data[i][27].toString().trim()
                  : null;
              }

              PartnerInfoExcelObj.parent.Note = !isNullOrUndefined(data[i][28])
                ? data[i][28].toString().trim()
                : "";

              PartnerInfoExcelObj.parent.ReceiveFMV = !isNullOrUndefined(
                data[i][29]
              )
                ? data[i][29].toString().trim()
                : null;
              PartnerInfoExcelObj.parent.VestingAcceleration = !isNullOrUndefined(
                data[i][30]
              )
                ? data[i][30].toString().trim()
                : null;

              PartnerInfoExcelArr.push(PartnerInfoExcelObj);
            }
            self.dataPartnerInfoExcel = PartnerInfoExcelArr;
            self.gridDataPartnerInfoExcel = [];

            for (var i = 0; i < PartnerInfoExcelArr.length; i++) {
              self.gridDataPartnerInfoExcel.push(PartnerInfoExcelArr[i].parent);
            }

            var grid = $("#" + self.PartnerInfoUploadConfig.grid.gridId).data(
              "kendoGrid"
            );
            grid.dataSource.data(self.gridDataPartnerInfoExcel);
            console.log(JSON.stringify(self.gridDataPartnerInfoExcel));
          }else{
            this._AlertPopup("Template is Empty","error").then((result) => {
            })
          }
        };
        reader.readAsArrayBuffer(file);
      } catch (ex) {
        console.log(ex);
      }
    },

    validateFn(e) {
      const self = this;
      e.preventDefault();
      self.customerrors = [];
      self.isValid = true;
      let errorMessages = new Set();

      self.RemoveDuplicates();
      self.CheckIfExistingPartner();

      let dataItem = $("#" + self.PartnerInfoUploadConfig.grid.gridId)
        .data("kendoGrid")
        .dataSource.data();
      //API Data
      let CountriesApiData=self.withFilter(BaseModelCountries.list);
      let StatesApiData=self.withFilter(BaseModelStates.list);

      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );

      let chkBoxValue = [{ Option: "Yes" }, { Option: "No" }];
      let apiDocumentDeliveryMethod = response["DocumentDeliveryMethod"];
      let apiPartnerStatus = response["PartnerStatus"];
      let apiDomestic = response["Domestic"];
      let apiPosition = response["Position"];

      dataItem.forEach((ele, i) => {
        self.Columns = [];

        // Entity Name or Partner First, Last, Middle name is required.
        if (
          (isNullOrUndefined(ele.FirstName) || ele.FirstName == "") &&
          (isNullOrUndefined(ele.EntityName) || ele.EntityName == "")
        ) {
          self.Columns.push({ column: "FirstName", row: i });
          self.Columns.push({ column: "EntityName", row: i });
          errorMessages.add("The Person Name or Entity Name is required.");
        }

        // VestingAcceleration is required -- if PartnerStatus is Retired employee
        if (
          ele.PartnerStatus == "Retired Employee" &&
          ele.VestingAcceleration == "No"
        ) {
          self.Columns.push({ column: "VestingAcceleration", row: i });
          errorMessages.add("The Vesting Acceleration is required.");
        }

        // Termination date is required if employee type is former or retired employee
        if (
          (ele.PartnerStatus == "Retired Employee" ||
            ele.PartnerStatus == "Former Employee") &&
          !ele.LeaveDate
        ) {
          self.Columns.push({ column: "LeaveDate", row: i });
          errorMessages.add("The Termination Date is required.");
        }

        // If termination date is filled, employee type must be former or retired
        if (
          ele.PartnerStatus != "Retired Employee" &&
          ele.PartnerStatus != "Former Employee" &&
          ele.LeaveDate
        ) {
          self.Columns.push({ column: "PartnerStatus", row: i });
          errorMessages.add(
            "Termination Date is filled. Partner Status should be Former or Retired Employee!"
          );
        }

        // Hire Date is mandatory.
        if (!ele.HireDate && (ele.PartnerStatus != "Affiliated Partner" && ele.PartnerStatus != "General Partner" && ele.PartnerStatus != "TS Entity" ) ) 
        {
          self.Columns.push({ column: "HireDate", row: i });
          errorMessages.add("The Hire Date is required.");
        }

        if (ele.EMail &&!self._validateSpecialCharacter(ele.EMail,"email")) {
          self.Columns.push({ column: "EMail", row: i });
        errorMessages.add(`Email is invalid.`);
      }

        // Mail Address Same as Address checkbox value check
        let mailAddIndex = chkBoxValue.findIndex(
          obj => obj.Option == ele.CheckMailAddress
        );
        if (mailAddIndex < 0) {
          self.Columns.push({ column: "CheckMailAddress", row: i });
          errorMessages.add(
            "Please provide valid value for \"Mail Address Same as Registered Address\" .");
        }

        // Receive FMV checkbox value check
        let recFMVIndex = chkBoxValue.findIndex(
          obj => obj.Option == ele.ReceiveFMV
        );
        if (recFMVIndex < 0) {
          self.Columns.push({ column: "ReceiveFMV", row: i });
          errorMessages.add("Please provide a valid Receive FMV.");
        }

        // Vested Acceleration checkbox value check
        let vestAccIndex = chkBoxValue.findIndex(
          obj => obj.Option == ele.VestingAcceleration
        );
        if (vestAccIndex < 0) {
          self.Columns.push({ column: "VestingAcceleration", row: i });
          errorMessages.add("Please provide a valid Vesting Acceleration.");
        }

        // PartnerStatus value check
        let partstsIndex = apiPartnerStatus.findIndex(
          obj => obj.Option == ele.PartnerStatus
        );
        if (partstsIndex < 0) {
          self.Columns.push({ column: "PartnerStatus", row: i });
          errorMessages.add("Please provide a valid Partner Status.");
        }

        // US Status value check
        let usStsIndex = apiDomestic.findIndex(
          obj => obj.Option == ele.Domestic
        );
        if (usStsIndex < 0) {
          self.Columns.push({ column: "Domestic", row: i });
          errorMessages.add("Please provide a valid US Status.");
        }

        // DocumentDeliveryMethod value check
        let delvryIndex = apiDocumentDeliveryMethod.findIndex(
          obj => obj.Option == ele.DocumentDeliveryMethod
        );
        if (delvryIndex < 0) {
          self.Columns.push({ column: "DocumentDeliveryMethod", row: i });
          errorMessages.add("Please provide a valid Document Delivery Method.");
        }

        // Postion value check
        let Positionindex = apiPosition.findIndex(
          obj => obj.Option == ele.Position
        );
        if (Positionindex < 0 && !isNullOrUndefined(ele.Position) && ele.Position!="" ) {
          self.Columns.push({ column: "Position", row: i });
          errorMessages.add("Please provide a valid Position.");
        }
        //Country Validation
        let countryIndex = CountriesApiData.findIndex(f => f.CountryName == ele.Country)
          if(!isNullOrUndefined(ele.Country) && countryIndex < 0){
            self.Columns.push({"column":"Country","row":i});
            errorMessages.add("Country is Invalid")
          }
        //State Validation
        if (!isNullOrUndefined(ele.Country) && ele.Country.trim()=="United States of America") {
          let stateIndex = StatesApiData.findIndex(f => f.StateName == ele.State)
          if(!isNullOrUndefined(ele.State) && stateIndex < 0){
            self.Columns.push({"column":"State","row":i});
            errorMessages.add("State Column should have a valid US State")
          }
        }
        if (ele.CheckMailAddress && ele.CheckMailAddress.trim().toLowerCase()=="no") {
        //Mail Country Validation
        let mailCountryIndex = CountriesApiData.findIndex(f => f.CountryName == ele.MailCountry)
          if(!isNullOrUndefined(ele.MailCountry) && mailCountryIndex < 0){
            self.Columns.push({"column":"MailCountry","row":i});
            errorMessages.add("MailCountry is Invalid")
          }
        //Mail State Validation
        if (!isNullOrUndefined(ele.MailCountry) && ele.MailCountry.trim()=="United States of America") {
          let mailStateIndex = StatesApiData.findIndex(f => f.StateName == ele.MailState)
          if(!isNullOrUndefined(ele.MailState) && mailStateIndex < 0){
            self.Columns.push({"column":"MailState","row":i});
            errorMessages.add("Mail State Column should have a valid US State")
          }
        }
        }
        self.Columns.push({ column: "Validation", row: i });
         if (self.Columns.length != 1 && self.isValid) {
          self.isValid = false;
        }

        self.ValidateImportData(
          self.PartnerInfoUploadConfig.grid.gridId,
          self.Columns
        );
      });

      self.customerrors = [...errorMessages];

      if (self.customerrors.length == 0 && dataItem.length) {
        self.flgValid = false;
      }
    },

    CheckIfExistingPartner() {
      const self = this;

      let Partner = this.withFilter(self.BaseModelPartner.list);
      let excelData = self.gridDataPartnerInfoExcel;
      var InvalidPartnerId = "";

      for (let i = 0; i < excelData.length; i++) {
        if (excelData[i].PartnerID) {
          let result = Partner.filter(function(obj) {
            if (obj.PartnerID) {
              return (
                obj.PartnerID.toString()
                  .trim()
                  .toLowerCase() ==
                excelData[i].PartnerID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (!result) {
            InvalidPartnerId =
              InvalidPartnerId + excelData[i].PartnerID.toString() + ", ";
          }
        }
      }
      //return true;
      if (InvalidPartnerId.length) {
        self.customerrors.push(
          "PartnerID(s): " +
            InvalidPartnerId.substring(0, InvalidPartnerId.length - 2) +
            " does not exist in our database.Please provide a valid partner Id"
        );
      }
    },

    RemoveDuplicates: function() {
      const self = this;

      let isUnique = true;
      let arr = self.gridDataPartnerInfoExcel;
      let flag = 0;
      let duplicate = [];
      let a = arr.reduce(function(accumulator, current) {
        if (checkIfAlreadyExist(current)) {
          flag = 1;
          duplicate.push([current]);
          return accumulator;
        } else {
          return accumulator.concat([current]);
        }

        function checkIfAlreadyExist(currentVal) {
          return accumulator.some(function(item) {
            return (
              item.PartnerID == currentVal.PartnerID && currentVal.PartnerID
            );
          });
        }
      }, []);

      if ((flag = 1 && duplicate.length > 0)) {
        self.customerrors.push("Please ensure Partner has unique PartnerID.");
        console.log(JSON.stringify(duplicate));
        isUnique = false;
      }

      return isUnique;
    },

    EditPartner: function(e) {
      const self = this;
      e.preventDefault();
      self.modalConfig.modalName = "Edit Partner";
      self.modalConfig.modalAddorEdit = "Edit";

      self.$refs.refPartnerInfoForm.getInputControls();

      var gview = window.$("#partnerUploadGrid").data("kendoGrid");
      var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(JSON.stringify(dataItem1));

      if (self.dataPartnerInfoExcel.length) {
        let result = self.dataPartnerInfoExcel.filter(function(obj) {
          return (
            obj.parent.PartnerInfoKey.toString()
              .trim()
              .toLowerCase() ==
            dataItem.PartnerInfoKey.toString()
              .trim()
              .toLowerCase()
          );
        })[0];

        if (result) {
          self.PartnerInfoJSON = JSON.parse(JSON.stringify(result));
        }
        self.PartnerInfoJSON.parent.ReceiveFMV =
          self.PartnerInfoJSON.parent.ReceiveFMV == "Yes" ? true : false;
        self.PartnerInfoJSON.parent.VestingAcceleration =
          self.PartnerInfoJSON.parent.VestingAcceleration == "Yes"
            ? true
            : false;
      }

      window.$("#BaseModal").modal("toggle");
    },

    refreshGrid() {
      const self = this;

      if (self.dataPartnerInfoExcel.length) {
        let updatedRow = self.dataPartnerInfoExcel.findIndex(function(obj) {
          return (
            obj.parent.PartnerInfoKey.toString()
              .trim()
              .toLowerCase() ==
            self.PartnerInfoJSON.parent.PartnerInfoKey.toString()
              .trim()
              .toLowerCase()
          );
        });

        self.dataPartnerInfoExcel[updatedRow].parent = {};
        self.dataPartnerInfoExcel[updatedRow].parent =
          self.PartnerInfoJSON.parent;

        self.gridDataPartnerInfoExcel = [];
        for (var i = 0; i < self.dataPartnerInfoExcel.length; i++) {
          self.gridDataPartnerInfoExcel.push(
            self.dataPartnerInfoExcel[i].parent
          );
        }
      }
    },

    DeleteDIfromGrid: function(e) {
      const self = this;
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          self.customerrors = [];
          self.flgValid = true;
          var grid = window
            .$("#" + self.PartnerInfoUploadConfig.grid.gridId)
            .data("kendoGrid");
          var dataItem = grid.dataItem(window.$(e.currentTarget).closest("tr"));

          let objIndex = self.dataPartnerInfoExcel.findIndex(function(obj) {
            return obj.parent.PartnerInfoKey == dataItem.PartnerInfoKey;
          });
          self.dataPartnerInfoExcel.splice(objIndex, 1);

          self.gridDataPartnerInfoExcel = [];
          for (var i = 0; i < self.dataPartnerInfoExcel.length; i++) {
            self.gridDataPartnerInfoExcel.push(
              self.dataPartnerInfoExcel[i].parent
            );
          }

          grid.dataSource.data(self.gridDataPartnerInfoExcel);
        }
      });
    },

    SavePartner: function(e) {
      const self = this;
      e.preventDefault();

      if (self.gridDataPartnerInfoExcel.length) {
        for (var i = 0; i < self.gridDataPartnerInfoExcel.length; i++) {
          if (self.gridDataPartnerInfoExcel[i].PartnerID) {
            // existing partner data
          } else {
            // New partner data
            const result = self.withFilter(self.BaseModelPartner.list, "");

            if (result.length <= 0) {
              if (i == 0) {
                self.gridDataPartnerInfoExcel[i].PartnerID = 100001;
              } else {
                self.gridDataPartnerInfoExcel[i].PartnerID = 100001 + i;
              }
            } else {
              let nextPartnerID = self._getIncrementalID(result, "PartnerID");
              if (i == 0) {
                self.gridDataPartnerInfoExcel[i].PartnerID = nextPartnerID;
              } else {
                self.gridDataPartnerInfoExcel[i].PartnerID = nextPartnerID + i;
              }
            }
          }
        }
      }

      let createObject = {
        Partner: {
          config: BaseModelPartner,
          createData: self.gridDataPartnerInfoExcel
        }
      };
      //let loader = this.$loading.show();
      self._APICrudPopup("APICrudpopup");
      this.CreateAllItems(createObject).then(Partner => {
        console.log(Partner);
        /** commented becuase audit log should completed before user navigating to other page. */
          // self._AlertPopup("Investment data saved successfully", "success");

          /** AUDIT DOCUMENT UPLOAD **/
          let FileUpload = [];
          let senderObj = {};
          //senderObj.Id = this.count++;
          let realfileName = this.inputfile.UploadFile[0].name;
         // senderObj.File = self._appendDatewithExcelName(fileName);
          senderObj.File = this.inputfile.UploadFile[0].upload.uuid
          senderObj.RealFileName = realfileName;
          senderObj.FileContent = this.inputfile.UploadFile[0];
          FileUpload.push(senderObj);
          this.UploadBulkAditFilesToDB(FileUpload)
            .then(response => {
              self._AlertPopup("Partner Information saved successfully", "success");
            })
            .catch(error => {
              self._AlertPopup("Some Error Occurred!", "info");
            })
            .finally(() => {
              //loader.hide();
            });
          /** AUDIT DOCUMENT UPLOAD END */
        this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
      }).catch(error=>{
          self._AlertPopup("Some Error Occurred!","info");
      }).finally(()=>{
        //loader.hide();
      })
    },

    ClearForm() {
      const self = this;

      self.customerrors = [];
      self.gridDataPartnerInfoExcel = [];
      self.dataPartnerInfoExcel = [];
      self.displayPage = false;
      self.flgValid=false;
      self.isValid=false;
    }
  }
};
</script>
